import {
  Paper,
  ToggleButtonGroup,
  ToggleButton,
  Typography,
} from "@mui/material";

export default function ShiftDisplayOptions({
  shiftDisplay = "initials",
  setShiftDisplay,
  t,
}) {
  return (
    <Paper
      elevation={2}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 1,
        p: 1,
        borderRadius: 3,
        bgcolor: "background.paper",
      }}
    >
      <Typography variant="h6">{t("Display as")}</Typography>

      <ToggleButtonGroup
        value={shiftDisplay}
        exclusive
        onChange={(_, value) => value && setShiftDisplay(value)}
        aria-label={t("shiftDisplayOptions")}
        size="small"
      >
        <ToggleButton value="name">{t("Name")}</ToggleButton>
        <ToggleButton value="initials">{t("Only initials")}</ToggleButton>
        <ToggleButton value="numbers">{t("As Numbers")}</ToggleButton>
      </ToggleButtonGroup>
    </Paper>
  );
}
